/**
 * User group type is used to filter particular types of user groups out
 * e.g. When removing a user from a court system (removing all their groups),
 * we do not want to remove them from a user group
 */
export var UserGroupType;
(function (UserGroupType) {
    /**
     * The default - there is nothing special about these user groups.
     * Default groups should NOT include BillToUserGroup or ViewOrderPrices permissions
     */
    UserGroupType["Default"] = "default";
    /**
     * Billing group is a special-case group that has slightly different rules around how it operates
     * and where it should appear in For The Record
     * Billing group permissions include: BillToUserGroup, PlaceOrderWithoutHolds and ViewOrderPrices
     */
    UserGroupType["BillingGroup"] = "billing-group";
})(UserGroupType || (UserGroupType = {}));
export class UserGroup {
    constructor() {
        this.groupType = UserGroupType.Default;
    }
}
